// **************************
// REASON WITHOUT DELIVERY
// **************************

export const getReasonWithoutDeliveryList = (language) => {
    switch (language) {
        case 'pt':
            return REASONS_WITHOUT_DELIVERY;
        break;
        case 'en':
            return EN_REASONS_WITHOUT_DELIVERY;
        break;
        case 'es':
            return ES_REASONS_WITHOUT_DELIVERY;
        break;
        case 'fr':
            return FR_REASONS_WITHOUT_DELIVERY;
        break;
        default:
            break;
    }
}

// PT Version

export const REASON_LOST = { name: "Perda", code: "Perda" };
export const REASON_ROBBERY = { name: "Furto", code: "Furto" };
export const REASON_ACCIDENT = { name: "Acidente", code: "Acidente" };
export const REASON_OTHER = { name: "Outro", code: "Outro" };

export const REASONS_WITHOUT_DELIVERY = [
    REASON_LOST,
    REASON_ROBBERY,
    REASON_ACCIDENT,
    REASON_OTHER
];

// EN Version

export const EN_REASON_LOST = { name: "Lost", code: "Perda" };
export const EN_REASON_ROBBERY = { name: "Theft", code: "Furto" };
export const EN_REASON_ACCIDENT = { name: "Accident", code: "Acidente" };
export const EN_REASON_OTHER = { name: "Other", code: "Outro" };

export const EN_REASONS_WITHOUT_DELIVERY = [
    EN_REASON_LOST,
    EN_REASON_ROBBERY,
    EN_REASON_ACCIDENT,
    EN_REASON_OTHER
];

// ES Version

export const ES_REASON_LOST = { name: "Pérdida", code: "Perda" };
export const ES_REASON_ROBBERY = { name: "Robo", code: "Furto" };
export const ES_REASON_ACCIDENT = { name: "Accidente", code: "Acidente" };
export const ES_REASON_OTHER = { name: "Otro", code: "Outro" };

export const ES_REASONS_WITHOUT_DELIVERY = [
    ES_REASON_LOST,
    ES_REASON_ROBBERY,
    ES_REASON_ACCIDENT,
    ES_REASON_OTHER
];

// FR Version

export const FR_REASON_LOST = { name: "Perte", code: "Perda" };
export const FR_REASON_ROBBERY = { name: "Vol", code: "Furto" };
export const FR_REASON_ACCIDENT = { name: "Accident", code: "Acidente" };
export const FR_REASON_OTHER = { name: "Autre", code: "Outro" };

export const FR_REASONS_WITHOUT_DELIVERY = [
    FR_REASON_LOST,
    FR_REASON_ROBBERY,
    FR_REASON_ACCIDENT,
    FR_REASON_OTHER
];

// **************************
// REASON WITH DELIVERY
// **************************

export const getReasonWithDeliveryList = (language) => {
    switch (language) {
        case 'pt':
            return REASONS_WITH_DELIVERY;
        break;
        case 'en':
            return EN_REASONS_WITH_DELIVERY;
        break;
        case 'es':
            return ES_REASONS_WITH_DELIVERY;
        break;
        case 'fr':
            return FR_REASONS_WITH_DELIVERY;
        break;
        default:
            break;
    }
}

// PT Version

export const REASON_DAMAGED = { name: "Danificada", code: "Danificada" };
export const REASON_CHANGE_DATA = { name: "Alteração de Dados", code: "Alteração de Dados" };

export const REASONS_WITH_DELIVERY = [
    REASON_DAMAGED,
    REASON_CHANGE_DATA,
    REASON_OTHER
];

// EN Version

export const EN_REASON_DAMAGED = { name: "Damaged", code: "Danificada" };
export const EN_REASON_CHANGE_DATA = { name: "Data Change", code: "Alteração de Dados" };

export const EN_REASONS_WITH_DELIVERY = [
    EN_REASON_DAMAGED,
    EN_REASON_CHANGE_DATA,
    EN_REASON_OTHER
];

// ES Version

export const ES_REASON_DAMAGED = { name: "Dañado", code: "Danificada" };
export const ES_REASON_CHANGE_DATA = { name: "Cambio de datos", code: "Alteração de Dados" };

export const ES_REASONS_WITH_DELIVERY = [
    ES_REASON_DAMAGED,
    ES_REASON_CHANGE_DATA,
    ES_REASON_OTHER
];

// FR Version

export const FR_REASON_DAMAGED = { name: "Endommagé", code: "Danificada" };
export const FR_REASON_CHANGE_DATA = { name: "Modification des données", code: "Alteração de Dados" };

export const FR_REASONS_WITH_DELIVERY = [
    FR_REASON_DAMAGED,
    FR_REASON_CHANGE_DATA,
    FR_REASON_OTHER
];
